import React from "react";

const InnerPlayIcon = ({ style, size = 20 }) =>
  <svg width={size} height={size} style={style} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.1668 5.83337L5.8335 14.1667M5.8335 5.83337L14.1668 14.1667" stroke="#2D2C44" strokeOpacity="0.7" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>;

export default InnerPlayIcon;

